"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Toasts = exports.ShortcutProvider = exports.useShortcutRegister = exports.useShortcutHandler = exports.SupportedCommandList = void 0;
const react_1 = __importStar(require("react"));
const uuid_1 = require("uuid");
const react_bootstrap_1 = require("react-bootstrap");
exports.SupportedCommandList = [
    "SaveAndNextScript",
    "NextScript",
    "PreviousScript",
];
const ShortcutHandlerContext = (0, react_1.createContext)({
    map: {},
    register: () => "",
    unregister: () => { },
    activeToasts: new Set(),
    activateToast: () => { },
    deactivateToast: () => { },
});
function useShortcutHandler(command) {
    var _a;
    const value = (0, react_1.useContext)(ShortcutHandlerContext);
    const list = (_a = value.map[command]) !== null && _a !== void 0 ? _a : [];
    const { activateToast } = value;
    return (0, react_1.useCallback)(() => {
        activateToast(command);
        for (const { handler } of list) {
            handler();
        }
    }, [list, activateToast, command]);
}
exports.useShortcutHandler = useShortcutHandler;
function useShortcutRegister(command, handler) {
    const value = (0, react_1.useContext)(ShortcutHandlerContext);
    (0, react_1.useEffect)(() => {
        const key = value.register(command, handler);
        return () => {
            value.unregister(command, key);
        };
    }, [command, handler, value.register, value.unregister]);
}
exports.useShortcutRegister = useShortcutRegister;
const ShortcutProvider = ({ children, }) => {
    const [map, setMap] = (0, react_1.useState)({});
    const [toastSet, setToastSet] = (0, react_1.useState)(new Set());
    const register = (0, react_1.useCallback)((command, handler) => {
        const key = (0, uuid_1.v4)();
        setMap((prev) => {
            var _a;
            return (Object.assign(Object.assign({}, prev), { [command]: [...((_a = prev[command]) !== null && _a !== void 0 ? _a : []), { handler, key }] }));
        });
        return key;
    }, []);
    const activateToast = (0, react_1.useCallback)((command) => {
        setToastSet((prev) => new Set([...prev, command]));
    }, []);
    const unregister = (0, react_1.useCallback)((command, handlerId) => {
        setMap((prev) => {
            var _a;
            return (Object.assign(Object.assign({}, prev), { [command]: ((_a = prev[command]) !== null && _a !== void 0 ? _a : []).filter(({ key }) => key !== handlerId) }));
        });
    }, []);
    const deactivateToast = (0, react_1.useCallback)((command) => {
        setToastSet((prev) => {
            const newSet = new Set(prev);
            newSet.delete(command);
            return newSet;
        });
    }, []);
    const context = (0, react_1.useMemo)(() => ({
        map,
        register,
        unregister,
        activeToasts: toastSet,
        activateToast,
        deactivateToast,
    }), [map, register, unregister, toastSet]);
    return (react_1.default.createElement(ShortcutHandlerContext.Provider, { value: context }, children));
};
exports.ShortcutProvider = ShortcutProvider;
const keyAndEffects = [
    {
        name: "SaveAndNextScript",
        keyAndEffect: (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("code", null, "Ctrl"),
            " + ",
            react_1.default.createElement("code", null, "\u2192"),
            " (\u7FFB\u8A33\u3092\u78BA\u5B9A\u3057\u3001\u6B21\u306E\u7FFB\u8A33\u3078\u9032\u3080)")),
    },
    {
        name: "NextScript",
        keyAndEffect: (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("code", null, "Ctrl"),
            " + ",
            react_1.default.createElement("code", null, "\u2193"),
            " (\u6B21\u306E\u7FFB\u8A33\u3078\u9032\u3080)")),
    },
    {
        name: "PreviousScript",
        keyAndEffect: (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("code", null, "Ctrl"),
            " + ",
            react_1.default.createElement("code", null, "\u2191"),
            " (\u524D\u306E\u7FFB\u8A33\u3078\u623B\u308B)")),
    },
];
const Toasts = () => {
    const { activeToasts, deactivateToast } = (0, react_1.useContext)(ShortcutHandlerContext);
    return (react_1.default.createElement(react_bootstrap_1.ToastContainer, { position: "bottom-end", className: "position-fixed m-4" }, keyAndEffects.map(({ name, keyAndEffect }) => (react_1.default.createElement(react_bootstrap_1.Toast, { key: name, show: activeToasts.has(name), autohide: true, onClose: () => deactivateToast(name), delay: 1000 },
        react_1.default.createElement(react_bootstrap_1.ToastHeader, null,
            react_1.default.createElement("strong", { className: "me-auto" }, "\u30B7\u30E7\u30FC\u30C8\u30AB\u30C3\u30C8\u8D77\u52D5")),
        react_1.default.createElement(react_bootstrap_1.ToastBody, null, keyAndEffect))))));
};
exports.Toasts = Toasts;
